import { render } from "./ButtonModule.vue?vue&type=template&id=c6230c4e&scoped=true"
import script from "./ButtonModule.vue?vue&type=script&lang=js"
export * from "./ButtonModule.vue?vue&type=script&lang=js"

import "./ButtonModule.vue?vue&type=style&index=0&id=c6230c4e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6230c4e"]])

export default __exports__